import PhoneNumber from 'awesome-phonenumber';

export default {
  getMessage: field => `${field} is not a valid phone number`,
  validate(value) {
    return new Promise((resolve) => {
      const phone = new PhoneNumber(value, 'CA');
      resolve({ valid: phone.isValid() });
    });
  },
};
